import { useState, useEffect } from "react"
import axios from "axios"

import { BASE_URL, ORGANIZATIONS_API, SUBCATEGORIES_API } from "../../../../../Utilities/APIs"

function ViewOrganization({

    //common props
    targetID, employee

}) {

    const [item, setItem] = useState(null)
    const [subcategories, setSubcategories] = useState(null)

    useEffect(() => {

      const config = {
          headers: {
              Authorization: `Bearer ${employee.token}`
          }
      }
  
      async function fetchAndSetItem() {
      
          const {data} = await axios.get(ORGANIZATIONS_API + targetID, config)

          setItem(data);
      }
  
      fetchAndSetItem()

      async function fetchAndSetSubcategories() {
      
          const {data} = await axios.get(SUBCATEGORIES_API, config)

          setSubcategories(data);
      }
  
      fetchAndSetSubcategories()

      
    }, [targetID, employee.token])

    return (
      <div className="crud_view_content">

        {item &&
        <>
          <h1>Name</h1>
          <p>{item.name}</p>

          <h1>English Name</h1>
          <p>{item.engName}</p>

          <h1>Description</h1>
          <p>{item.description}</p>

          <h1>English Description</h1>
          <p>{item.engDescription}</p>

          <h1>Subcategory</h1>
          <p>{subcategories?.find(sub => sub._id === item.subcategory).name}</p>

          <h1>Cost</h1>
          <p>{item.cost}</p>

          <h1>Head Office Area</h1>
          <p>{item.headOfficeArea}</p>

          <h1>Card Image</h1>
          <img src={BASE_URL + item.cardImage.slice(6,item.cardImage.length)} alt={item.name} />

          <h1>Cover Image</h1>
          <img src={BASE_URL + item.coverImage.slice(6,item.coverImage.length)} alt={item.name} />
        </>
        }
      </div>
    )
}

export default ViewOrganization